import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { CssUtils } from '@hdms/shared/util-core';

@Component({
  selector: 'shrd-uic-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextComponent {
  @Input() class = '';
  @Input() ngClass: NgClass['ngClass'];
  @Input() bgColor = '';
  @HostBinding('class')
  get hostClasses(): string {
    return CssUtils.getJoinedClassList('shrd-uic-text', this.class, this.ngClass, this.bgColor, {
      'has-bg': this.bgColor
    });
  }
}
